// 关键版本
export const KeyVerEnums = {
    // 端内支持新签名方式
    SUPPORT_SIGN_V2: "3.1.46",
};


// WEBPACK FOOTER //
// ./src/const.js